import React from "react";
import { useSelector } from "types/store";
import styles from "./style.module.css";
import DynamicWidthSelector from "components/ChatGPT/DynamicWidthSelector";
import * as viewReducer from "containers/View/reducer";
import { selectOnChangeWrapper } from "@/utils/select";
import * as nextReducer from "@/containers/Next/NextReducer";
const ProjectSelector = ({ onChange, selectorStyle, menuPlacement, className, isDisabled, isNewChat, isDynamic, isStyled, color, filter, projectId }) => {
    const reports = useSelector((state) => viewReducer.getReports(state)).filter((r) => r?.metadata?.explorations?.[0]?.projectId !== undefined);
    const nexts = useSelector((state) => nextReducer.getBase(state));
    const reportOptions = (typeof filter === "function" ? reports.filter(filter) : reports).map((report) => {
        const nextReport = nexts?.[report?.id];
        return {
            value: report,
            label: (nextReport?.reportLabel ? nextReport?.reportLabel : report.name) +
                (nextReport?.projectId ? ` (${nextReport?.projectId})` : "")
        };
    });
    const reportId = reports.find((r) => r?.metadata?.explorations?.[0]?.projectId == projectId);
    const retValue = reportOptions.find((v) => v.value.id === reportId);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.datasetSelector + " " + (className ? className : "") },
            React.createElement(DynamicWidthSelector, { options: reportOptions, value: retValue, onChange: selectOnChangeWrapper((r) => onChange(r?.metadata?.explorations?.[0]?.projectId)), placeholder: "Select Project", menuPlacement: menuPlacement ?? "top", isDisabled: isDisabled, isSearchable: true, isDynamic: isDynamic, isNewChat: isNewChat, isStyled: isStyled, style: selectorStyle, color: color }))));
};
export default ProjectSelector;
